/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.tools.ToolSafety
*/
export var ToolSafety;
(function (ToolSafety) {
    ToolSafety["SAFE_PROBE"] = "SAFE_PROBE";
    ToolSafety["MUTATING"] = "MUTATING";
})(ToolSafety || (ToolSafety = {}));
//# sourceMappingURL=ToolSafety.js.map